/* eslint-disable */

export interface QueryParams {
  platform?: string | undefined;
  contextUri?: string | undefined;
  /**
   *  in seconds
   */
  playbackTimestamp?: number | undefined;
}

const baseQueryParams: object = {};

export const protobufPackage = 'spotify.reporting.webform';

export const QueryParams = {
  fromJSON(object: any): QueryParams {
    const message = { ...baseQueryParams } as QueryParams;
    if (object.platform !== undefined && object.platform !== null) {
      message.platform = String(object.platform);
    } else {
      message.platform = undefined;
    }
    if (object.contextUri !== undefined && object.contextUri !== null) {
      message.contextUri = String(object.contextUri);
    } else {
      message.contextUri = undefined;
    }
    if (object.playbackTimestamp !== undefined && object.playbackTimestamp !== null) {
      message.playbackTimestamp = Number(object.playbackTimestamp);
    } else {
      message.playbackTimestamp = undefined;
    }
    return message;
  },
  fromPartial(object: DeepPartial<QueryParams>): QueryParams {
    const message = { ...baseQueryParams } as QueryParams;
    if (object.platform !== undefined && object.platform !== null) {
      message.platform = object.platform;
    } else {
      message.platform = undefined;
    }
    if (object.contextUri !== undefined && object.contextUri !== null) {
      message.contextUri = object.contextUri;
    } else {
      message.contextUri = undefined;
    }
    if (object.playbackTimestamp !== undefined && object.playbackTimestamp !== null) {
      message.playbackTimestamp = object.playbackTimestamp;
    } else {
      message.playbackTimestamp = undefined;
    }
    return message;
  },
  toJSON(message: QueryParams): unknown {
    const obj: any = {};
    message.platform !== undefined && (obj.platform = message.platform);
    message.contextUri !== undefined && (obj.contextUri = message.contextUri);
    message.playbackTimestamp !== undefined && (obj.playbackTimestamp = message.playbackTimestamp);
    return obj;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | undefined;
type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;
